import { SubscriptionInterval } from '@platform-frontend/checkout-drop-in';

export interface SubscriptionKind<T = SubscriptionInterval> {
  type: 'SUBSCRIPTION';
  subscriptionInterval: T;
}
